/**
 * Based on the heating degree days (HDD) value, determine the climate zone.
 * This follows the Canadian National Building Code (NBC) climate zone definitions.
 *
 * @param {number} hdd - Heating Degree Days value
 * @returns {string|null} - Climate zone (e.g., 'Zone 4', 'Zone 5', etc.) or null if not applicable
 */
export const getClimateZone = hdd => {
  if (hdd == null) {
    return null;
  }
  if (hdd < 3000) {
    return 'Zone 4';
  }
  if (hdd < 4000) {
    return 'Zone 5';
  }
  if (hdd < 5000) {
    return 'Zone 6';
  }
  if (hdd < 6000) {
    return 'Zone 7A';
  }
  if (hdd < 7000) {
    return 'Zone 7B';
  }
  if (hdd >= 7000) {
    return 'Zone 8';
  }

  return null;
};
